import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const VehicleApi = createApi({
  reducerPath: "vehicle",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BACKEND_URL,
    credentials: "include",
  }),
  endpoints: (builder) => ({
    listAllVehicles: builder.query({
      query: () => "/vehicles/all",
    }),
    getAllVehicles: builder.query({
      query: (val) => {
        const page = val.page ?? 1;
        const limit = val.limit ?? 5;
        return `/vehicles?page=${page}&limit=${limit}&sortBy=id&sortOrder=desc`;
      },
    }),
    getVehiclesSearch: builder.query({
      query: ({ page, search }) =>
        `/vehicles?page=${page}&limit=5&search=${search}&sortBy=id&sortOrder=desc`,
    }),
    getSpecificVehicle: builder.query({
      query: (id) => `/vehicles/${id}`,
    }),
    getSpecificVehicleImei: builder.query({
      query: (imei) => `/vehicles/imei/${imei}`,
    }),
    addVehicles: builder.mutation({
      query: (val) => {
        const formData = new FormData();
        for (const key in val) {
          if (Array.isArray(val[key])) {
            val[key].forEach((file) => {
              formData.append(key, file);
            });
          } else if (val[key] !== null) {
            formData.append(key, val[key]);
          }
        }
        return {
          url: "/vehicles/register",
          method: "POST",
          body: formData,
        };
      },
    }),

    editVehicle: builder.mutation({
      query: ({ id, val }) => ({
        url: `vehicles/${id}`,
        method: "PUT",
        body: val,
      }),
    }),

    editVehicleAttachments: builder.mutation({
      query: ({ vehicleId, attachments }) => {
        const formData = new FormData();
        if (Array.isArray(attachments)) {
          // Handle array fields like attachments
          attachments.forEach((file) => {
            formData.append("attachments", file);
          });
        }
        return {
          url: `/vehicles/${vehicleId}/attachments`,
          method: "PUT",
          body: formData,
        };
      },
    }),
    deleteVehicle: builder.mutation({
      query: (val) => ({
        url: `vehicles/${val}`,
        method: "DELETE",
        body: val,
      }),
    }),

    dashboardCountDifference: builder.query({
      query: () => "/vehicles/countDifference",
    }),
    dashboardCharts: builder.query({
      query: () => "/vehicles/charts",
    }),

    deleteVehicleAttachments: builder.mutation({
      query: (id) => ({
        url: `vehicles/attachments/${id}`,
        method: "DELETE",
      }),
    }),
    bulkUploadVehicles: builder.mutation({
      query: (formData) => ({
        url: "/vehicles/bulk-upload", // replace with your actual endpoint
        method: "POST",
        body: formData,
      }),
    }),
    totalDashboardCounts: builder.query({
      query: () => "/dashboard/statistics",
    }),
    getChildVehicles: builder.query({
      query: () => "/vehicles/users/vehicles",
    }),
  }),
});

export const {
  useListAllVehiclesQuery,
  useGetAllVehiclesQuery,
  useGetVehiclesSearchQuery,
  useGetSpecificVehicleQuery,
  useGetSpecificVehicleImeiQuery,
  useLazyGetAllVehiclesQuery,
  useLazyGetSpecificVehicleQuery,
  useAddVehiclesMutation,
  useEditVehicleMutation,
  useEditVehicleAttachmentsMutation,
  useDeleteVehicleMutation,
  useDeleteVehicleAttachmentsMutation,
  useDashboardCountDifferenceQuery,
  useDashboardChartsQuery,
  useBulkUploadVehiclesMutation,
  useTotalDashboardCountsQuery,
  useGetChildVehiclesQuery,
} = VehicleApi;
